var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatiscticsCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#FD9C00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5648_135153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4302 13C18.3719 13 13.4434 18.0567 13.4434 24.2726C13.4434 30.4884 18.3719 35.5451 24.4302 35.5451C30.4886 35.5451 35.4171 30.4884 35.4171 24.2726C35.4171 18.0567 30.4886 13 24.4302 13ZM24.4302 33.6663C22.1413 33.6663 20.051 32.7937 18.4442 31.3639C18.4515 31.3517 18.4616 31.3414 18.468 31.3292C19.9805 28.729 19.0293 27.1405 18.327 26.4247C18.1421 26.2359 17.9306 26.0639 17.7127 25.8911C17.1432 25.4374 16.766 25.1377 16.766 24.2726C16.766 23.8649 16.9875 23.7052 18.0817 23.3219C18.8343 23.0579 19.6867 22.7592 20.2369 22.0293C21.5141 20.3347 20.1096 17.7213 19.8148 17.2141C19.6638 16.9538 19.4999 16.7096 19.3296 16.4757C20.7057 15.5251 22.3482 14.9577 24.1134 14.8947C24.3991 15.3917 24.8706 15.8106 25.3339 16.2193C25.7294 16.5687 26.3575 16.7152 26.6807 17.1286C26.8657 17.3653 26.7759 17.8218 26.7823 18.1206C26.7952 18.7133 27.1449 19.5728 28.3242 19.5728C28.3764 19.5728 28.4304 19.571 28.4862 19.5672C28.9422 19.5343 30.365 19.1999 31.7951 18.7152C32.9158 20.2746 33.586 22.1928 33.586 24.2726C33.586 29.4523 29.4787 33.6663 24.4302 33.6663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6476 21.3633C26.2046 21.3633 24.7315 22.0669 23.9825 23.1133C23.4799 23.816 23.3334 24.6286 23.5696 25.4017C24.0411 26.9441 24.0869 27.8535 23.7921 28.8727C23.5302 29.7782 23.5046 31.0915 24.9997 31.7171C25.2817 31.8355 25.5912 31.8956 25.9171 31.8956C27.0286 31.8956 28.3443 31.1901 29.5282 29.9586C30.951 28.4791 31.7878 26.6661 31.7677 25.1067C31.7402 23.0081 29.9301 21.3633 27.6476 21.3633Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5648_135153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(13.4434 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatiscticsCafe);
export default __webpack_public_path__ + "static/media/statisctics-cafe.8c49c188817cfa840ab305c4a1378f99.svg";
export { ForwardRef as ReactComponent };